var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import AppBody from "../../components/AppBody";
import { Button } from "@savvyinsure/react-ui";
import Header from "../../components/Header";
import Image from "../../components/Image";
import RouteHeaderLogo from "../../components/RouteHeaderLogo";
import RouteTitle from "../../components/RouteTitle";
import { completedPage } from "../../lib/Avo";
import useAffiliateConfig from "../../hooks/useAffiliateConfig";
import useAppSelector from "../../hooks/useAppSelector";
var buttonText = "Call Us";
export default function HomeMidFunnelAdsRoute() {
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var helpPhoneNumber = useAffiliateConfig().helpPhoneNumber;
    function handleClick() {
        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: buttonText, optionSelected: buttonText }));
        window.open("tel:+".concat(helpPhoneNumber), "_self");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null,
            React.createElement(RouteHeaderLogo, null)),
        React.createElement(AppBody, { className: "items-center px-6 text-center", centerContent: true },
            React.createElement("div", null,
                React.createElement(Image, { src: "/assets/images/home-mid-funnel-ads.png", alt: "", width: 220, height: 204, className: "mb-6" })),
            React.createElement(RouteTitle, { className: "mb-6 px-7" },
                "Homeowners can save up to ",
                React.createElement("strong", null, "$1,100/year"),
                " with our licensed agents!"),
            React.createElement(Button, { className: "mb-5", onClick: handleClick },
                React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", className: "mr-2 h-4 w-4" },
                    React.createElement("path", { fillRule: "evenodd", d: "M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z", clipRule: "evenodd" })),
                React.createElement("span", null, buttonText)),
            React.createElement("p", { className: "flex items-center justify-center" },
                React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "#F3BE3E", className: "mr-2 h-6 w-6" },
                    React.createElement("path", { fillRule: "evenodd", d: "M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z", clipRule: "evenodd" })),
                React.createElement("span", null,
                    React.createElement("strong", null, "4.8/5"),
                    " Rating on TrustPilot\u00AE")))));
}
